export var FieldType;
(function (FieldType) {
    FieldType["TextInput"] = "text";
    FieldType["TextareaInput"] = "textarea";
    FieldType["NumberInput"] = "number";
    FieldType["PhoneInput"] = "phone";
    FieldType["EmailInput"] = "email";
    FieldType["DropdownInput"] = "dropdown";
    FieldType["RadioInput"] = "radio";
    FieldType["CheckboxInput"] = "checkbox";
    FieldType["DatepickerInput"] = "datepicker";
    FieldType["Password"] = "password";
    FieldType["TimepickerInput"] = "time";
    FieldType["HTMLContent"] = "htmlcontent";
    FieldType["Hidden"] = "hidden";
    FieldType["Captcha"] = "recaptcha";
})(FieldType || (FieldType = {}));
